import {PaginationParams} from '../model/pagination';

export function cleaningParams(params: PaginationParams): any {
  const cleanParams: any = {};
  Object.keys(params).forEach(key => {
    const value = (params as any)[key];
    if (value !== undefined && value !== null && value !== '') {
      cleanParams[key] = value;
    }
  });
  return cleanParams;
}
